import { Seance } from "domain/entities/seances.entities";
import { Sequence } from "domain/entities/techniques.entities";

export const getDurationInHours = (duration: number) => {
  const days = Math.floor(duration / 1440);
  const remainingTime = duration - Math.floor(days * 1440);
  const hours = Math.floor(remainingTime / 60);
  const minutes = Math.floor(remainingTime - hours * 60);

  return duration === 0
    ? "0min"
    : `${days ? days + "j" : ""} ${
        hours ? (days ? `0${hours}`.slice(-2) : hours) + "h" : ""
      } ${minutes ? (hours ? `0${minutes}`.slice(-2) : minutes) + "min" : ""}`;
};

export const parseDuration = (duration: string) => {
  const [hours, minutes] = duration.split(":");
  return (hours ? parseInt(hours) * 60 : 0) + (minutes ? parseInt(minutes) : 0);
};

export const formatDuration = (duration: string) => {
  if (!duration) return "0:00";
  const hours = Math.floor(parseInt(duration) / 60);
  const minutes = parseInt(duration) % 60;
  return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
};

export const getParticipantsToString = (participants: number) => {
  return participants > 0 ? `lte${participants}` : "gte20";
};

export const getTotalSeanceDuration = (seance: Seance) => {
  if (seance.userId && seance?.techniques?.length > 0) {
    return seance.techniques.reduce(
      (acc, technique) => acc + Number(technique.duration),
      0
    );
  } else return Number(seance.duration) || 0;
};

export const getTotalSequencesDuration = (sequences: Sequence[]) => {
  if (sequences.length > 0) {
    return sequences.reduce((acc, seq) => acc + parseDuration(seq.duration), 0);
  } else return 0;
};

export const textWithLinksToReact = (text: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);
  return parts.map((part, i) =>
    urlRegex.test(part) ? (
      <a
        key={text + i}
        className="hover:underline"
        href={part}
        target="_blank"
        rel="noreferrer"
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};

export const textWithLinksToMarkdown = (text: string) => {
  const containsMarkdownLinkRegex = /\[.*\]\((https?:\/\/[^\s]+)\)/g;

  if (text.match(containsMarkdownLinkRegex)) {
    return text;
  }

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, (url) => `[${url}](${url})`);
};
